import Button from '@/components/atoms/Button';
import { cn } from '@/lib/utils';

function getTextClassNames(isSelected: boolean, tag: 'H2' | 'H3'): string {
  let result = '';

  if (tag === 'H3') {
    if (isSelected) {
      result += 'text-body-m-bold';
    } else {
      result += 'text-body-m';
    }
  } else if (tag === 'H2') {
    if (isSelected) {
      result += 'text-body-l-bold';
    } else {
      result += 'text-body-l';
    }
  }

  if (isSelected) {
    result += ' text-brand-500';
  } else {
    result += ' text-gray-400 hover:text-brand-500';
  }

  return result;
}

const SideNavigationEntry = ({
  text,
  tag,
  id,
  isSelected,
  handleClick,
}: {
  text: string;
  tag: 'H2' | 'H3';
  id: string;
  isSelected: boolean;
  handleClick: () => void;
}) => {
  const shouldShowHighlight = isSelected && tag === 'H2';

  return (
    <div
      className='relative flex items-center'
      id={id}
      data-tracker-component='shortcut'
    >
      <span
        className={cn(
          'absolute -top-[-1px] left-0 h-full rounded bg-gray-300',
          shouldShowHighlight ? 'w-0.5 bg-brand-500' : 'w-px'
        )}
      />
      <Button
        onClick={handleClick}
        variant='text'
        textWrap
        classNames={{
          inner: cn(
            'w-full justify-start text-left',
            getTextClassNames(isSelected, tag)
          ),
          root: cn(
            'w-full py-1 h-auto active:bg-base-white hover:bg-base-white',
            tag === 'H2' ? 'px-3  mt-2' : 'px-8 mt-1'
          ),
        }}
      >
        {text}
      </Button>
    </div>
  );
};

export default SideNavigationEntry;
